import { BubbleLineIcon, Space, Text } from 'ui';

type P = {
  type?: string;
};

const Type = ({ type }: P) => {
  if (!type) {
    return null;
  }

  return (
    <Space>
      <BubbleLineIcon />
      <Text>{type}</Text>
    </Space>
  );
};

export default Type;
